import SimpleSelect from "../../common/components/elements/select/SimpleSelect";
import React, {useMemo} from "react";
import {required} from "../../common/validations";
import Error from "../../common/components/elements/Error";
import {Field} from "react-final-form";
import useMarketingSources from "../hooks/useMarketingSources";
import useFeatureToggles from "../../common/hooks/useFeatureToggles";
import {showErrorHighlight} from "src/core/common/utils";
import {FieldContainer} from "src/core/common/components/collections/form/forms";

function MarketingSourceSelect() {
  const toggles = useFeatureToggles();
  const [marketingSources] = useMarketingSources();
  const selectOptions = useMemo(() => {
    const elements = marketingSources ? marketingSources.getElements() : [];
    return elements.map((marketingSource) => ({
      label: marketingSource.getName(),
      value: marketingSource.getName(),
    }));
  }, [marketingSources]);
  const fieldRequired = toggles.requireMarketingSourceOnSignUp();
  return (
    <Field
      name="marketingSource"
      validate={fieldRequired ? required : undefined}
      render={({input, meta}) => (
        <FieldContainer>
          <SimpleSelect
            {...input}
            placeholder={`How did you hear about us?${fieldRequired ? "*" : ""}`}
            hasErrors={showErrorHighlight(meta)}
            options={selectOptions}
          />
          {meta.touched && <Error>{meta.error}</Error>}
        </FieldContainer>
      )}
    />
  );
}

export default MarketingSourceSelect;
